export default __webpack_public_path__ + "static/media/icon-face-bad-18x15.e9b8e7a8.svg";